import { render, staticRenderFns } from "./RecycledDraftList.vue?vue&type=template&id=71b76a2e&scoped=true"
import script from "./RecycledDraftList.vue?vue&type=script&lang=js"
export * from "./RecycledDraftList.vue?vue&type=script&lang=js"
import style0 from "./RecycledDraftList.vue?vue&type=style&index=0&id=71b76a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b76a2e",
  null
  
)

export default component.exports